<template>
    <ul class="navbar-nav ms-auto h-100 scrollable-menu2">
        <li class="nav-item">
            <a class="nav-link" :href="startUrl">
                Start a New Loan
            </a>
        </li>        
        <li class="nav-item">
            <a class="nav-link" @click="goToMyProfile">
                My Profile 
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" @click="logout">
                Logout
            </a>
        </li>
    </ul>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';

    export default {
        name: 'user-context-menu',
        data() {
            return {
                startUrl: '' 
            }
        },
        computed: {
            ...mapGetters(['siteLinks'])
        },
        mounted() {
            this.startUrl = this.siteLinks.find( ({ key }) => key === 'startUrl' ).url
        },
        methods: {
            ...mapActions(['logout']),
            goToMyProfile() {
                this.$router.push({ path: '/account/username/change' });
            }
        },
    }
</script>

